import { useState, useRef, useId } from 'react';
import emailjs from '@emailjs/browser';
import { Dialog, useDialog } from '../ui';
import profile from '../../data/profile/profile.json';
import './connect.css';

const SOCIALS = [
  { label: 'GitHub', key: 'github' },
  { label: 'LinkedIn', key: 'linkedin' },
  { label: 'Twitter', key: 'twitter' },
  { label: 'Instagram', key: 'instagram' },
  { label: 'Strava', key: 'strava' },
];

const FIELDS = [
  { name: 'name', label: 'Your name', type: 'text' },
  { name: 'email', label: 'Your email', type: 'email' },
];

const ContactForm = ({ onClose }) => {
  const form = useRef();
  const id = useId();
  const [status, setStatus] = useState(null); // null | sending | success | error

  const submit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    const { serviceId, templateId, userId } = profile.emailjs;
    try {
      await emailjs.sendForm(serviceId, templateId, form.current, userId);
      form.current?.reset();
      setStatus('success');
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="contact__done" role="status">
        <p>Sent. I will reply to the address you gave.</p>
        <button type="button" className="pill" onClick={onClose}>Close</button>
      </div>
    );
  }

  return (
    <form ref={form} onSubmit={submit} className="contact__form">
      {/* Real labels. The old form was placeholder-only, which leaves a
          screen-reader user with three unnamed fields. */}
      {FIELDS.map((f) => (
        <div className="contact__field" key={f.name}>
          <label htmlFor={`${id}-${f.name}`}>{f.label}</label>
          <input id={`${id}-${f.name}`} type={f.type} name={f.name} required />
        </div>
      ))}

      <div className="contact__field">
        <label htmlFor={`${id}-message`}>Message</label>
        <textarea id={`${id}-message`} name="message" rows="4" required />
      </div>

      {status === 'error' && (
        <p className="contact__error" role="alert">
          That did not send. Try again, or email me directly at {profile.contact.email}.
        </p>
      )}

      <button
        type="submit"
        className="pill pill--primary contact__submit"
        disabled={status === 'sending'}
      >
        {status === 'sending' ? 'Sending…' : 'Send'}
      </button>
    </form>
  );
};

const ConnectSection = () => {
  const modal = useDialog();

  return (
    <section className="connect" id="connect" aria-labelledby="connect-heading">
      <div className="container">
        <h2 className="connect__heading" id="connect-heading">Let&rsquo;s connect</h2>
        <p className="connect__sub">
          Code, running, or just life. I would like to hear from you either way.
        </p>

        <div className="connect__actions">
          {SOCIALS.map(({ label, key }) => (
            profile.social[key] && (
              <a
                key={key}
                className="pill"
                href={profile.social[key]}
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </a>
            )
          ))}
          <a className="pill" href={`mailto:${profile.contact.email}`}>Email</a>
          <button
            type="button"
            className="pill pill--primary"
            aria-haspopup="dialog"
            onClick={(e) => modal.open(true, e)}
          >
            Send a message
          </button>
        </div>
      </div>

      {modal.isOpen && (
        <Dialog title="Send a message" onClose={modal.close}>
          <ContactForm onClose={modal.close} />
        </Dialog>
      )}
    </section>
  );
};

export default ConnectSection;
